import Application from "../../Application";

import { IReportService } from "../../service/report/ReportService";
import { INotificationService } from "../../service/notification/NotificationService";
import Report8Presenter, {
  IReport8Presenter
} from "../../presenter/report/Report8Presenter";

export default class ShowReport8PageInteractor {
  private application: Application;
  private output?: IReport8Presenter;
  private reportService: IReportService;
  private notificationService: INotificationService;

  constructor(application, reportService, notificationService) {
    this.application = application;
    this.reportService = reportService;
    this.notificationService = notificationService;
  }

  async getReportingPeriodList() {
    try {
      return this.reportService.getReportingPeriodList();
    } catch (error) {
      this.notificationService.showError((error as any).message);
    }
  }

  execute() {
    this.output = Report8Presenter({
      application: this.application,
      initialState: {
        report8ReportingPeriodList: [],
        report8ApplicantList: [],
        report8SelectedApplicantIds: [],
        report8CurrentReportingPeriod: undefined,
        report8: undefined
      }
    });

    this.getReportingPeriodList().then(
      (reportingPeriodList) =>
        this.output &&
        this.output.setReportingPeriodList(reportingPeriodList || [])
    );

    return this.output;
  }
}
